//-- ******************* produccion default  ******************* 

let urlDefault = `https://middlewarenew.nuvem.cloud/`;
let UrlSeguros = `https://middlewarenew.nuvem.cloud/`;
let UrlFinanciero = process.env.REACT_APP_FINANCIERO || 'http://middlewarepruebasdesarrollo.us-west-2.elasticbeanstalk.com/' // poner url de produccion
let urlDefaultRetorno = process.env.REACT_APP_RETORNO || 'https://plugin.nuvem.cloud/'
let urlDominio = process.env.REACT_APP_DOMINIO || 'https://website-prod-pluginv2.nuvem.cloud/';
let UrlServicios = process.env.REACT_APP_SERVICIOS || "https://servicios.nuvem.cloud/api/";

// export const UrlBase = 'https://middlewarenew.nuvem.cloud/';
export const UrlBase = urlDefault;
export const UrlBaseServicios = UrlServicios;
export const UrlBaseFinanciero = UrlFinanciero

export const UrlImagenes = 'https://s3-us-west-2.amazonaws.com/middleware-images/';
export const urlSubirArchivo = 'https://s3-us-west-2.amazonaws.com/middleware-images/';
export const urlDocumentosPlugin = 'https://s3-us-west-2.amazonaws.com/middleware-images/'

export const URL_PLUGIN = `${UrlBase}backend/web/index.php?r=plugin/`;
export const URL_PLUGIN_FRONTEND = `${UrlBase}frontend/web/index.php?r=plugin/`;
export const URL_PLUGIN_FRONT_GENERAL = `${UrlBase}frontend/web/index.php?r=`;
export const URL_PLUGIN_PROD = `${UrlBase}backend/web/index.php?r=plugin/`;  // talvez eliminar
export const URL_PLUGIN_SEGUROS = `${urlDefault}frontend/web/index.php?r=plugin/`;
export const URL_EDIT_VIGENCIA_COTIZACION = `${URL_PLUGIN}edit-vigencia-cotizacion`;
export const URL_VERIFICAR_TOKEN = `${UrlBase}backend/web/index.php?r=plugin/verificar-token&setJson=false`;
export const URL_PAYPAL = `${UrlBase}frontend/web/index.php?r=paypal/`;
export const URL_COTIZACIONES = `${UrlBase}frontend/web/index.php?r=cotizaciones/`;
export const URL_CORREO = `${UrlBase}frontend/web/index.php?r=plugin/cotizacion/correo-inicial-sunidos`;

export const URL_RETORNO = process.env.REACT_APP_URL_RETORNO || urlDefaultRetorno;
//export const URL_RETORNO =  'https://newversion-website-dev.plugin.nuvem.cloud/'
export const dominio = urlDominio;